// Lightweight logging utility.
//
// Wraps console with levels and an [Area] tag convention (matches the existing
// "[Signup] ..." style already used in components). In production, debug/info
// are no-ops to keep the console quiet; warnings and errors always print so
// production failures leave a trace. This is the single place to later route
// errors to an external tracker (e.g. Sentry) without touching call sites.

const isProduction = process.env.NODE_ENV === 'production'

function format(area, args) {
    return area ? [`[${area}]`, ...args] : args
}

export const logger = {
    debug(area, ...args) {
        if (isProduction) return
        // eslint-disable-next-line no-console
        console.debug(...format(area, args))
    },
    info(area, ...args) {
        if (isProduction) return
        // eslint-disable-next-line no-console
        console.info(...format(area, args))
    },
    warn(area, ...args) {
        // eslint-disable-next-line no-console
        console.warn(...format(area, args))
    },
    error(area, ...args) {
        // eslint-disable-next-line no-console
        console.error(...format(area, args))
        // TODO (Phase 5): forward to error-tracking service here.
    },
}

// Extract the useful context from an axios error for logging. Keeps the full
// picture (method, url, status, server detail) even when the user only sees a
// short, friendly message.
export function describeApiError(error) {
    if (!error) return { message: 'Unknown error' }

    const config = error.config || {}
    const response = error.response

    if (response) {
        return {
            method: (config.method || '').toUpperCase(),
            url: config.url,
            status: response.status,
            detail: response.data && (response.data.detail || response.data.message || response.data),
        }
    }

    // No response: network failure, timeout, or request never sent.
    return {
        method: (config.method || '').toUpperCase(),
        url: config.url,
        status: null,
        detail: error.message,
    }
}

export default logger
